export const NAME = 'i18n';

/**
 * Here goes the actionTypes
 */

export const CHANGE_CURRENT_LOCALE = 'CHANGE_CURRENT_LOCALE';

export const PATH_TO_PARTNER = 'feature.partenaire';
export const PATH_TO_UPTO = `${PATH_TO_PARTNER}.jusqua`;
export const PATH_TO_INSTEADOF = `${PATH_TO_PARTNER}.aulieude`;



// WEBPACK FOOTER //
// ./src/services/i18n/constants.js